module.exports = __webpack_public_path__ + "img/20190527162307631.2a10ab8f.png";